import { render, staticRenderFns } from "./serveContent.vue?vue&type=template&id=8a154194&scoped=true&"
import script from "./serveContent.vue?vue&type=script&lang=js&"
export * from "./serveContent.vue?vue&type=script&lang=js&"
import style0 from "./serveContent.vue?vue&type=style&index=0&id=8a154194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a154194",
  null
  
)

export default component.exports